"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useAppointmentStore = void 0;
const pinia_1 = require("pinia");
const fetch_1 = __importDefault(require("../../common/utils/fetch"));
const i18n_1 = __importDefault(require("../../common/i18n"));
exports.useAppointmentStore = (0, pinia_1.defineStore)("appointmentStore", {
    state: () => ({
        dates: {},
        reload: false,
    }),
    getters: {},
    actions: {
        async getAppointments(year, month, reservedServiceLocationId, tyreFittingServiceSKU) {
            this.reload = false;
            //itt hozzá kell adni egyet mert a javascript 0-11-ig számolja a hnapokat a symfony pedig 1-12-ig
            month += 1;
            this.dates = {};
            return new Promise((resolve, reject) => {
                (0, fetch_1.default)("/api/get/appointments", {
                    method: "POST",
                    headers: { "Content-Type": "application/json" },
                    body: JSON.stringify({
                        year: year,
                        month: month,
                        location: reservedServiceLocationId,
                        service: tyreFittingServiceSKU,
                    }),
                })
                    .then((response) => {
                    if (typeof response.error !== "undefined") {
                        // refresh failed
                        reject(i18n_1.default.trans("frontend_appointment_error", "No bookable dates were found using the search criteria!", "frontend"));
                        return;
                    }
                    Object.entries(response).forEach(([index, value]) => {
                        value["monthDay"] = index;
                        this.dates[index] = value;
                    });
                    resolve();
                })
                    .catch((error) => {
                    reject(error);
                });
            });
        },
    },
});
